// Get all cards with modals
const modals = document.querySelectorAll('.modals .modal');
const modalBackground = document.querySelector('.modals__background');
loadModals(modals);

function loadModals(modals) {
  modals.forEach(modal => {
    let modalItem = modal.querySelector('.modal__item');
    let showBtn = modal.querySelector('.modal__button-open');
    let closeBtn = modal.querySelector('.modal__button-close');
    showBtn.addEventListener('click', function (event) {
      event.preventDefault();
      // If not currently expanded
      if (showBtn.getAttribute('aria-expanded') == 'false') {
        modalItem.removeAttribute('hidden');
        showBtn.setAttribute('aria-expanded', 'true');
        closeBtn.setAttribute('aria-expanded', 'true');
        toggleModalOverlay();
      }
    });
    closeBtn.addEventListener('click', function (event) {
      event.preventDefault();
      // If currently expanded
      if (closeBtn.getAttribute('aria-expanded') == 'true') {
        modalItem.setAttribute('hidden', '');
        showBtn.setAttribute('aria-expanded', 'false');
        closeBtn.setAttribute('aria-expanded', 'false');
        toggleModalOverlay(false);
      }
    });
  });
}

function toggleModalOverlay(active = true) {
  if (active) {
    document.body.classList.add('noScroll');
    modalBackground.classList.add('active');
  } else {
    document.body.classList.remove('noScroll');
    modalBackground.classList.remove('active');
  }
}

if (modalBackground) {
  modalBackground.addEventListener('click', function (event) {
    if (this.classList.contains('active')) {
      modals.forEach(modal => {
        let showBtn = modal.querySelector('.modal__button-open');
        let closeBtn = modal.querySelector('.modal__button-close');
        if (showBtn.getAttribute('aria-expanded') == 'true') {
          modal.querySelector('.modal__item').setAttribute('hidden', '');
          showBtn.setAttribute('aria-expanded', 'false');
          closeBtn.setAttribute('aria-expanded', 'false');
          toggleModalOverlay(false);
        }
      });
    }
  });
}


const shareLinks = document.querySelectorAll('.modal__item__content .share-link');
const url = window.location.href;

const modalQueryString = window.location.search;
const modalUrlParams = new URLSearchParams(modalQueryString);

if (shareLinks) {
  shareLinks.forEach(shareLink => {
    shareLink.addEventListener('click', function (event) {
      let thisUrl = url;
      let accid = shareLink.closest('.accordion__item__content').id.replace(/accordion-panel-/g, '');
      let modid = this.dataset.share;

      if (modalUrlParams.has('accid') && modalUrlParams.has('modid')) {
        thisUrl = thisUrl.replace('accid=' + modalUrlParams.get('accid'), 'accid=' + accid);
        thisUrl = thisUrl.replace('modid=' + modalUrlParams.get('modid'), 'modid=' + modid);
      } else {
        thisUrl += '?accid=' + accid + '&modid=' + modid;
      }

      //console.log(thisUrl);
      navigator.clipboard.writeText(thisUrl);
      shareLink.classList.add('active');
      setTimeout(function () {
        shareLink.classList.remove('active');
      }, 3000);
    });
  });
}


if (modalUrlParams.has('accid') && modalUrlParams.has('modid')) {
  let thisAccordion = document.getElementById('accordion-button-' + modalUrlParams.get('accid'));
  let thisModal = document.getElementById('modal-btn-' + modalUrlParams.get('modid'));
  window.addEventListener('load', function () {
    thisAccordion.scrollIntoView();
    setTimeout(function () {
      thisAccordion.click();
    }, 1000);
    setTimeout(function () {
      thisModal.click();
    }, 2000);
  });


}





